// Ficha de producto Kbellos — adaptado del HTML original
(() => {
  const mainImage = document.querySelector('#main-product-image');
  if (!mainImage) return;

  const galleryImages = [...document.querySelectorAll('.thumbnail')].map((t) => t.dataset.image);
  let galleryIndex = 0;
  const quantityOutput = document.querySelector('#quantity');
  const toast = document.querySelector('.toast');
  const lightbox = document.querySelector('.product-lightbox');
  const lightboxImage = lightbox?.querySelector('figure img');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let galleryAnimating = false;

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  function syncGallery(index) {
    galleryIndex = (index + galleryImages.length) % galleryImages.length;
    const thumbnail = document.querySelectorAll('.thumbnail')[galleryIndex];
    if (!thumbnail) return;
    mainImage.src = galleryImages[galleryIndex];
    mainImage.alt = thumbnail.querySelector('img')?.alt || 'Imagen del producto';
    if (lightboxImage) { lightboxImage.src = mainImage.src; lightboxImage.alt = mainImage.alt + ' ampliado'; }
    document.querySelectorAll('.thumbnail').forEach((item, i) => item.classList.toggle('is-active', i === galleryIndex));
  }

  async function setGalleryImage(index, direction = 1) {
    if (galleryAnimating) return;
    const nextIndex = (index + galleryImages.length) % galleryImages.length;
    if (reduceMotion) { syncGallery(nextIndex); return; }
    galleryAnimating = true;
    const distance = direction >= 0 ? -44 : 44;
    const exit = mainImage.animate([{opacity:1,transform:'translateX(0) scale(1)'},{opacity:0,transform:`translateX(${distance}px) scale(.96)`}],{duration:180,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
    await exit.finished;
    syncGallery(nextIndex);
    const enter = mainImage.animate([{opacity:0,transform:`translateX(${-distance}px) scale(.96)`},{opacity:1,transform:'translateX(0) scale(1)'}],{duration:380,easing:'cubic-bezier(.16,1,.3,1)',fill:'forwards'});
    await enter.finished;
    exit.cancel(); enter.cancel();
    galleryAnimating = false;
  }

  document.querySelectorAll('.thumbnail').forEach((thumbnail, index) => thumbnail.addEventListener('click', () => setGalleryImage(index, index >= galleryIndex ? 1 : -1)));
  document.querySelector('.gallery-prev')?.addEventListener('click', () => setGalleryImage(galleryIndex - 1, -1));
  document.querySelector('.gallery-next')?.addEventListener('click', () => setGalleryImage(galleryIndex + 1, 1));

  // Lightbox
  function openLightbox() {
    if (!lightbox || !lightboxImage) return;
    lightboxImage.src = mainImage.src;
    lightboxImage.alt = mainImage.alt + ' ampliado';
    lightbox.showModal();
  }
  document.querySelector('.zoom-button')?.addEventListener('click', openLightbox);
  lightbox?.querySelector('.lightbox-close')?.addEventListener('click', () => lightbox.close());
  lightbox?.querySelector('.lightbox-prev')?.addEventListener('click', () => setGalleryImage(galleryIndex - 1, -1));
  lightbox?.querySelector('.lightbox-next')?.addEventListener('click', () => setGalleryImage(galleryIndex + 1, 1));
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });

  // Swipe en imagen principal
  let pointerStart = 0;
  document.querySelector('.product-main-image')?.addEventListener('pointerdown', (event) => { if (!event.target.closest('button')) pointerStart = event.clientX; });
  document.querySelector('.product-main-image')?.addEventListener('pointerup', (event) => {
    const distance = event.clientX - pointerStart;
    if (pointerStart && Math.abs(distance) > 42) setGalleryImage(galleryIndex + (distance < 0 ? 1 : -1), distance < 0 ? 1 : -1);
    pointerStart = 0;
  });

  // Cantidad
  document.querySelectorAll('[data-quantity]').forEach((button) => button.addEventListener('click', () => {
    const current = Number(quantityOutput?.textContent || 1);
    const next = button.dataset.quantity === 'increase' ? current + 1 : Math.max(1, current - 1);
    if (quantityOutput) quantityOutput.textContent = String(next);
    if (typeof renderPrice === 'function') renderPrice();
  }));

  // Favorito
  document.querySelector('.product-favorite')?.addEventListener('click', (event) => {
    const button = event.currentTarget;
    button.classList.toggle('is-active');
    button.setAttribute('aria-label', button.classList.contains('is-active') ? 'Quitar producto de favoritos' : 'Añadir producto a favoritos');
  });

  // Selector de variantes
  const variantData = (() => {
    try { return JSON.parse(document.getElementById('product-variant-json')?.textContent || '[]'); }
    catch { return []; }
  })();
  const optionSelects = [...document.querySelectorAll('.variant-option select')];
  const variantInput = document.querySelector('[name="id"]');
  const priceEl = document.querySelector('#product-price');
  const compareEl = document.querySelector('#product-compare-price');
  const savingEl = document.querySelector('#product-saving');
  const discountEl = document.querySelector('.product-discount');
  const stockText = document.querySelector('#stock-text');
  const stockDot = document.querySelector('#stock-dot');
  const money = (cents) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
  let unitPrice = 0;
  let unitCompare = 0;

  const renderPrice = () => {
    const qty = Number(quantityOutput?.textContent || 1);
    if (priceEl) priceEl.textContent = money(unitPrice * qty);
    const hasCompare = unitCompare > unitPrice;
    if (compareEl) { compareEl.hidden = !hasCompare; compareEl.textContent = hasCompare ? money(unitCompare * qty) : ''; }
    const pct = hasCompare ? Math.round((unitCompare - unitPrice) / unitCompare * 100) : 0;
    if (savingEl) { savingEl.hidden = !hasCompare; savingEl.textContent = hasCompare ? `Ahorra ${money((unitCompare - unitPrice) * qty)} (${pct}%)` : ''; }
    if (discountEl) { discountEl.textContent = `-${pct}%`; discountEl.hidden = !hasCompare; }
  };

  function applyVariant(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    unitPrice = variant.price;
    unitCompare = variant.compare_at_price || 0;
    renderPrice();
    if (stockText) stockText.textContent = variant.available ? 'En stock' : 'Agotado';
    stockDot?.classList.toggle('is-out', !variant.available);
    document.querySelectorAll('.product-add, .buy-now').forEach((b) => { b.disabled = !variant.available; });
    if (variant.image) {
      const idx = galleryImages.indexOf(variant.image);
      if (idx >= 0) setGalleryImage(idx);
      else { mainImage.src = variant.image; }
    }
  }

  // Precio inicial de la variante activa (para multiplicar por cantidad)
  const initialVariant = variantData.find((v) => String(v.id) === variantInput?.value) || variantData[0];
  if (initialVariant) { unitPrice = initialVariant.price; unitCompare = initialVariant.compare_at_price || 0; }

  const norm = (s) => String(s ?? '').trim().toLowerCase();
  function onOptionChange() {
    const selected = optionSelects.map((s) => s.value);
    const match = variantData.find((v) => v.options.every((o, i) => norm(o) === norm(selected[i])));
    if (match) applyVariant(match);
    else {
      if (stockText) stockText.textContent = 'No disponible';
      stockDot?.classList.add('is-out');
      document.querySelectorAll('.product-add, .buy-now').forEach((b) => { b.disabled = true; });
    }
  }
  optionSelects.forEach((s) => s.addEventListener('change', onOptionChange));

  // Dropdown de variantes (UI custom sobre el select oculto)
  document.querySelectorAll('[data-variant-dropdown]').forEach((dd) => {
    const trigger = dd.querySelector('.variant-dropdown__trigger');
    const valueEl = dd.querySelector('[data-variant-value]');
    const select = dd.querySelector('select');
    const close = () => { dd.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
    const markSelected = (opt) => {
      dd.querySelectorAll('.variant-dropdown__option').forEach((o) => {
        o.classList.toggle('is-selected', o === opt);
        o.setAttribute('aria-selected', String(o === opt));
      });
    };
    if (!select.value) valueEl?.classList.add('is-placeholder');
    trigger?.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !dd.classList.contains('is-open');
      closeVariantDropdowns();
      if (open) { dd.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    });
    dd.querySelectorAll('.variant-dropdown__option').forEach((opt) => {
      opt.addEventListener('click', () => {
        markSelected(opt);
        if (opt.dataset.variantId) {
          const v = variantData.find((x) => String(x.id) === opt.dataset.variantId)
            || {
              id: opt.dataset.variantId,
              price: Number(opt.dataset.price || 0),
              compare_at_price: Number(opt.dataset.compare || 0),
              available: opt.dataset.available === 'true',
              image: opt.dataset.image || null,
              options: [opt.dataset.value],
            };
          applyVariant(v);
          if (valueEl) { valueEl.textContent = opt.dataset.value; valueEl.classList.remove('is-placeholder'); }
          close();
          return;
        }
        select.value = opt.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        if (valueEl) { valueEl.textContent = opt.dataset.value; valueEl.classList.remove('is-placeholder'); }
        close();
      });
    });
    dd._close = close;
  });
  const closeVariantDropdowns = () => document.querySelectorAll('[data-variant-dropdown].is-open').forEach((d) => d._close?.());
  document.addEventListener('click', closeVariantDropdowns);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeVariantDropdowns(); });

  // Agregar al carrito (Shopify Cart API)
  const addToCartBtn = document.querySelector('.product-add');
  const buyNowBtn = document.querySelector('.buy-now');

  // Regalo: una oxigenta gratis por cada unidad de tinte (producto promo
  // 'Oxigenta de regalo' que el descuento automatico deja en $0). _tinte marca
  // la linea del tinte, _for_v enlaza el regalo con su variante y _gift_v
  // guarda la oxigenta elegida para que el carrito resincronice cantidades.
  const giftContext = () => {
    const giftEl = document.querySelector('#bt-inline [data-bt-check]:checked')?.closest('[data-bt-item]');
    const promoId = Number(document.querySelector('#bt-inline')?.dataset.promoVariant);
    const realId = Number(giftEl?.dataset.variantId);
    return giftEl && promoId && realId ? { giftEl, promoId, realId } : null;
  };

  const addToCart = async (relatedVariantId) => {
    const quantity = Number(quantityOutput?.textContent || 1);
    const variantId = relatedVariantId || document.querySelector('[data-product-form] [name="id"]')?.value;
    if (!variantId) { showToast('No se pudo agregar el producto.'); return; }
    const ctx = relatedVariantId ? null : giftContext();
    try {
      const items = [{ id: Number(variantId), quantity }];
      if (ctx) {
        items.push({ id: ctx.promoId, quantity, properties: {
          _for_v: Number(variantId),
          'Oxigenta elegida': ctx.giftEl.querySelector('.bt-inline__name')?.textContent.trim() || ''
        } });
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('cart-add-failed');
      if (window.kbellosUpdateCart) await window.kbellosUpdateCart();
      if (window.kbellosOpenCart) window.kbellosOpenCart();
      showToast('Producto agregado al carrito.');
    } catch { showToast('No pudimos agregar el producto. Intenta nuevamente.'); }
  };

  addToCartBtn?.addEventListener('click', () => addToCart());
  buyNowBtn?.addEventListener('click', async () => {
    await addToCart();
    setTimeout(() => { window.location.href = '/checkout'; }, 600);
  });

  // Tabs
  document.querySelectorAll('.tab-button').forEach((button) => button.addEventListener('click', () => {
    const panelId = button.getAttribute('aria-controls');
    document.querySelectorAll('.tab-button').forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
    document.querySelectorAll('.tab-button').forEach((tab) => tab.classList.toggle('is-active', tab === button));
    document.querySelectorAll('.tab-panel').forEach((panel) => { panel.hidden = panel.id !== panelId; panel.classList.toggle('is-active', panel.id === panelId); });
  }));

  // Productos relacionados: las tarjetas ya vienen renderizadas por Liquid,
  // solo conectamos el botón "Agregar al carrito" con la variante real
  const relatedGrid = document.querySelector('#related-grid');
  relatedGrid?.querySelectorAll('[data-related-variant]').forEach((button) => {
    button.addEventListener('click', () => addToCart(button.dataset.relatedVariant));
  });

  // Controles de strips horizontales (relacionados): scroll por página + estado en bordes
  document.querySelectorAll('.product-strip').forEach((strip) => {
    const grid = strip.querySelector('.related-grid, .recent-grid');
    if (!grid) return;
    const updateControls = () => {
      const max = grid.scrollWidth - grid.clientWidth - 1;
      strip.querySelector('.strip-prev')?.toggleAttribute('disabled', grid.scrollLeft <= 0);
      strip.querySelector('.strip-next')?.toggleAttribute('disabled', grid.scrollLeft >= max);
    };
    strip.querySelectorAll('.strip-control').forEach((button) => button.addEventListener('click', () => {
      const page = grid.clientWidth * 0.85;
      grid.scrollBy({ left: button.classList.contains('strip-next') ? page : -page, behavior: 'smooth' });
    }));
    grid.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });

  // Banners de la ficha: parallax + efectos de desplazamiento configurables
  const fxBanners = document.querySelectorAll('.product-feature-banner[data-parallax-speed]');
  if (fxBanners.length && !reduceMotion) {
    let fxTick = false;
    const updateFx = () => {
      fxBanners.forEach((banner) => {
        const rect = banner.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > window.innerHeight + 80) return;
        const p = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
        const speed = parseFloat(banner.dataset.parallaxSpeed) || 0;
        const effect = banner.dataset.effect;
        const img = banner.querySelector('.feature-parallax-bg');
        const copy = banner.querySelector('[data-fx-target]');
        if (img && effect !== 'kenburns') {
          let transform = `translate3d(0, ${(p - 0.5) * rect.height * speed * 2}px, 0)`;
          if (effect === 'zoom') transform += ` scale(${1.18 - p * 0.18})`;
          img.style.transform = transform;
        }
        if (copy) {
          if (effect === 'fade') copy.style.opacity = String(Math.max(0, 1 - Math.max(0, p - 0.55) * 2.4));
          else if (effect === 'rise') copy.style.transform = `translate3d(0, ${(p - 0.5) * -70}px, 0)`;
        }
      });
      fxTick = false;
    };
    window.addEventListener('scroll', () => {
      if (!fxTick) { window.requestAnimationFrame(updateFx); fxTick = true; }
    }, { passive: true });
    updateFx();
  }
})();

/* Bought Together inline */
(() => {
  const box = document.getElementById('bt-inline');
  if (!box) return;
  // Regalo: un solo producto elegible (radio). El total es solo el producto
  // principal; el regalo queda en $0 por el descuento automático de Shopify.
  const items = () => [...box.querySelectorAll('[data-bt-item]:not(.is-main)')];
  const sync = () => items().forEach((it) => it.classList.toggle('is-excluded', !it.querySelector('[data-bt-check]')?.checked));
  box.addEventListener('change', (e) => { if (e.target.matches('[data-bt-check]')) sync(); });
  sync();
})();
